export default __webpack_public_path__ + "static/media/sub22_v2.8cc65754.png";